import mutations from "../mutations/index_mutation";
import actions from "../actions/index_actions";
import getters from "../getters/index_getters";

export default {
  state: {
    current_user_id: null, // 当前INS账号的ID
    current_earn_coins_user_id: null, // 当前earn coins的ins_id
    master_user_id: null // GX主账号的ID
  },
  mutations,
  actions,
  getters
};
